<style scoped>
#login {
  background: url("../../assets/backImage/xiaoxian_bg.jpg") no-repeat;
  background-size: 100% 100%;
}

.center {
  text-align: center;
}

col {
  background: #fff;
  padding: 60px 60px 20px 60px;
  border-radius: 10px;
}

#login_top {
  width: 100%;
  height: 130px;
  line-height: 130px;
  background: url("../../assets/backImage/xiaoxian_login.png") no-repeat;
  background-size: 100% 100%;
  text-align: center;
  color: #fff;
  font-size: 34px;
}

#login_form {
  background: #fff;
  padding-top: 30px;
  padding-bottom: 10px;
  border-radius: 0 0 6px 6px;
  margin-top: 0;
}

input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 400px #e8eced inset;
}
</style>
<template>
  <Row type="flex" justify="center" align="middle" id="login">
    <Col span="5" style="min-width:320px">
      <div id="login_top">小 罐 茶 H 5 后 台</div>
      <Form
        ref="formInline"
        :model="formInline"
        :rules="ruleInline"
        label-position="top"
        id="login_form"
      >
        <FormItem style="width:60%;margin:0 auto">
          <Select
            prop="user"
            v-model="formInline.user"
            placeholder="请输入账号"
            @on-change="protocolChange"
            filterable
          >
            <Option
              v-for="(item,index) in protocolList"
              :value="item.store_name"
              :key="item.index"
            >{{ item.store_name }}</Option>
          </Select>
        </FormItem>
        <FormItem prop="password" style="width:60%;margin:22px auto 0px">
          <Input
            type="password"
            v-model="formInline.password"
            placeholder="请输入密码"
            @on-enter="handleSubmit('formInline')"
          >
            <Icon type="md-keypad" slot="prepend" color="#fc0a43" size="18"></Icon>
          </Input>
        </FormItem>
        <FormItem style="width:60%;margin:14px auto 0px"></FormItem>
        <FormItem class="center" style="width:20%;margin:0px auto 12px;">
          <Button
            type="primary"
            @click="handleSubmit('formInline')"
            style="background-color:#fc0a43; border-color:#fc0a43;"
            shape="circle"
            long
          >登录</Button>
        </FormItem>
      </Form>
    </Col>
  </Row>
</template>

<script>
export default {
  data() {
    return {
      single: !!(localStorage.getItem("tel") && localStorage.getItem("pwd")),
      username: "",
      formInline: {
        user: localStorage.getItem("tel") || "",
        password: localStorage.getItem("pwd") || ""
      },
      ruleInline: {
        user: [
          {
            required: true,
            message: "请输入账号",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur"
          },
          {
            type: "string",
            min: 1,
            message: "密码不能为空哦！",
            trigger: "blur"
          }
        ]
      },
      protocolList: []
    };
  },
  methods: {
    protocolChange(protocolId) {
      // console.log(protocolId)
    },
    handleSubmit(name) {
      const self = this;
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$axios
            .post("/h5/admin/login", {
              storeName: this.formInline.user,
              password: this.formInline.password
            })
            .then(res => {
              if (res.data.code === 0) {
                localStorage.setItem("xgth5user", this.formInline.user);
                let token = res.data.data.token;
                localStorage.setItem("xgth5token", token);
                self.$Message.success("登录成功咯");
                sessionStorage.clear();
                self.$router.push({ path: "/H5BackHome" });
              } else {
                self.$Message.error("登录失败咯");
              }
            });
        }
      });
    }
  },
  created() {
    this.$axios.post("/h5/admin/getStoreList", {}).then(res => {
      if (res.data.code === 0) {
        this.protocolList = res.data.data.data;
      } else {
        this.$Message.error("未获取到店铺信息");
      }
    });
  }
};
</script>
